import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import {EnumData} from "../../../../api/enum/enum.model";

@Component({
    selector: 'app-student-information-section',
    imports: [ReactiveFormsModule],
    templateUrl: './student-information-section.component.html'
})
export class StudentInformationSectionComponent {
    @Input() group!: FormGroup;
    @Input() genders: EnumData[] = [];
    @Input() religions: EnumData[] = [];
    @Input() motherTongue: EnumData[] = [];
    @Input() bloodGroupsType: EnumData[] = [];
    @Input() castCategoryType: EnumData[] = [];
    @Output() numbersOnly = new EventEmitter<any>();
}
